import { render } from "./zdDetail.vue?vue&type=template&id=60487c2e&scoped=true"
import script from "./zdDetail.vue?vue&type=script&lang=js"
export * from "./zdDetail.vue?vue&type=script&lang=js"

import "./zdDetail.vue?vue&type=style&index=0&id=60487c2e&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60487c2e"]])

export default __exports__